import { render, staticRenderFns } from "./billingPle.vue?vue&type=template&id=6fecdcb2&scoped=true"
import script from "./billingPle.vue?vue&type=script&lang=js"
export * from "./billingPle.vue?vue&type=script&lang=js"
import style0 from "./billingPle.vue?vue&type=style&index=0&id=6fecdcb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fecdcb2",
  null
  
)

export default component.exports